/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QualitySectionConfig } from '../../models/quality-section-config';

export interface ListQualitySectionConfigs$Params {
  id: string;
}

export function listQualitySectionConfigs(
  http: HttpClient,
  rootUrl: string,
  params: ListQualitySectionConfigs$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<QualitySectionConfig>>> {
  const rb = new RequestBuilder(rootUrl, listQualitySectionConfigs.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<QualitySectionConfig>>;
    })
  );
}

listQualitySectionConfigs.PATH = '/admin/program-period-configs/{id}/qualitySectionConfigs';
